import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import G from '../assets/G.png';
import V from '../assets/v.svg.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import galerie5 from '../assets/galerie5.png';
import galerie6 from '../assets/galerie6.png';
import galerie7 from '../assets/galerie7.jpeg';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.png';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import volcano from '../assets/volcano.jpeg';
import uber from '../assets/uber.png';
import deliveroo from '../assets/deliveroo.png';
import bein from '../assets/bein.png';
import volc from '../assets/volc.jpeg';
import volca from '../assets/volca.jpeg';
import menuv from '../assets/menuv.jpeg';
import menuv1 from '../assets/menuv1.jpeg';
import menuv3 from '../assets/menuv3.jpeg';
import delivery from '../assets/delivery.png';
import pizza from '../assets/pizza.jpeg';
import burger from '../assets/burger.jpg.webp';
import kebab from '../assets/kebab.jpg.webp';
import assietes from '../assets/assietes.jpg.webp';
import tacos from '../assets/tacos.jpg';
import naans from '../assets/naans.jpg';
import tiramisu from '../assets/tiramisu.jpg';
import avis1 from '../assets/avis1.png';
import pates from '../assets/pates.jpg';

export default {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
  volcano,
  V,
  bein,
  uber,
  deliveroo,
  volc,
  volca,
  menuv3,
  menuv1,
  menuv,
  delivery,
  pizza,
  tacos,
  burger,
  naans,
  tiramisu,
  kebab,
  avis1,
  pates,
  assietes,
  galerie5,
  galerie6,
  galerie7,
};

